const POS_TYPE_LABELS: Record<string, string> = {
    boyers_pa_feed: 'Boyers PA Feed',
};

export const formatPosTypeLabel = (posType: string): string => {
    const normalized = String(posType || '').trim();
    return POS_TYPE_LABELS[normalized] || normalized;
};
